import React, { useState, useEffect } from 'react';
import {
  PriceHeader
  , HomeContainer,
  FlexBox,
  ProfessionalBox,
  EnterpriseBox,
  EnterprisePlusBox,
  BoxTitle,
  BoxContent,
  PriceBox,
  SelectPackage,
  ImageBox,
  EnterpriseTitleBox,
  BoxTitle2
} from './styled';
import { Header } from '../../components/header/internals'
import Bookmark from '../../assets/bookmark.svg'
import * as apiClient from "../../common/apiClient";



export const Pricing = () => {
  const [isLoading, setIsLoading] = useState<any>(true);
  const [data, setData] = useState<any>([]);
  useEffect(() => {
    loadPackage();
  }, []);

  const loadPackage = () => {
    setIsLoading(true);
    apiClient.get('packages', null).then((response: any) => {
      setIsLoading(false);
      setData(response); 
    }).catch((err) => {
      setIsLoading(false);
    })

  };

  return (
    <HomeContainer>
      <Header />
      <PriceHeader>
        Product Packages and subscription plans
      </PriceHeader>
      {!isLoading && data.length > 0 && <FlexBox>
        <ProfessionalBox>
          <BoxTitle>{data.filter((item: any) => item.packageCode == 'P01')[0].package}</BoxTitle>
          <BoxContent>
            {/* The Professional Automotive Diagnostic Suite is a comprehensive solution designed to empower car mechanics and technicians with the tools they need to excel in their craft. This advanced package offers a range of features and capabilities aimed at streamlining diagnostics, enhancing efficiency, and delivering high-quality automotive repair services */}
            {data.filter((item: any) => item.packageCode == 'P01')[0].description}
          </BoxContent>
          <PriceBox>{data.filter((item: any) => item.packageCode == 'P03')[0].rate}/month</PriceBox>
          <SelectPackage style={{ background: '#FBBC05' }}>Select Plan</SelectPackage>
        </ProfessionalBox>
        <EnterpriseBox>
          <EnterpriseTitleBox>
            <BoxTitle2>
              {data.filter((item: any) => item.packageCode == 'P02')[0].package}

            </BoxTitle2>
            <ImageBox>
              <img src={Bookmark} />
            </ImageBox>
          </EnterpriseTitleBox>
          <BoxContent>
            {data.filter((item: any) => item.packageCode == 'P02')[0].description}
          </BoxContent>
          <PriceBox>{data.filter((item: any) => item.packageCode == 'P03')[0].rate}/month</PriceBox>

          <SelectPackage style={{ background: '#000000', width: '300px' }}>Select Plan</SelectPackage>
        </EnterpriseBox>
        <EnterprisePlusBox>
          <BoxTitle>{data.filter((item: any) => item.packageCode == 'P03')[0].package}</BoxTitle>
          <BoxContent>
            {data.filter((item: any) => item.packageCode == 'P03')[0].description}
          </BoxContent>
          <PriceBox>{data.filter((item: any) => item.packageCode == 'P03')[0].rate}/month</PriceBox>
          <SelectPackage style={{ background: '#4285F4' }}>Select Plan</SelectPackage>
        </EnterprisePlusBox>

      </FlexBox>
      }


    </HomeContainer>
  );
};
